import React from "react";

export default function ML_Regressions() {
  return (
    <div>
      <h1>ML_Regressions</h1>
      <p>This is the ML_Regressions component.</p>
    </div>
  );
}
